import { render } from "./CxAwarenessEventSetDetailsPanel.vue?vue&type=template&id=4f0c7b81"
import script from "./CxAwarenessEventSetDetailsPanel.vue?vue&type=script&lang=js"
export * from "./CxAwarenessEventSetDetailsPanel.vue?vue&type=script&lang=js"

import "./CxAwarenessEventSetDetailsPanel.vue?vue&type=style&index=0&id=4f0c7b81&lang=less"

import exportComponent from "/home/ec2-user/workspace/_conx-ui-monorepo_ui2_lab_master/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__